import React from 'react';
import { Mono } from '@jotpsych/ui';

import { codeFontSize } from './codeFontSize';

/**
 * A procedure code (or a "+N" fold of several) as a quiet inline chip.
 *
 * The code is boxed, not captioned: set in the same mono as the charge it
 * sits beside, a bare code reads as a second number glued to the first. The
 * hairline border on the page's own ground makes it a label instead, and the
 * secondary colour keeps it quieter than the figure.
 *
 * Not the design-system `Chip`: that is a 16px pill for statuses and tags,
 * and a code is neither.
 */
export const CodeChip: React.FC<{ children: string }> = ({ children }) => (
  <Mono
    sx={{
      bgcolor: 'background.default',
      border: '1px solid',
      borderColor: 'divider',
      borderRadius: 1,
      color: 'text.secondary',
      display: 'inline-block',
      fontSize: codeFontSize,
      /* No token expresses this: 18px inside the 1px border is the 20px of
         the theme's xSmall Chip, so the chip sits on the charge's baseline
         without lifting a 48px table row. */
      lineHeight: '18px',
      px: 0.75,
      whiteSpace: 'nowrap',
    }}
  >
    {children}
  </Mono>
);
